import styled from '@emotion/styled';
import { IconDown } from 'common/icons';
import { Link, Text, RotatableIcon, Flex, Image } from './styles';
import React, { useState } from 'react';

const AccordionTitleWrapper = styled(Link)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  flexWrap: 'nowrap',
  [`${RotatableIcon}`]: {
    flexShrink: 0,
    marginRight: theme.spacing(1),
  },
}));

const AccordionTitleImage = styled(Image)(() => ({
  width: 37,
  height: 24,
  '@media (max-width: 960px)': {
    width: 28,
    height: 17,
  },
}));

type AccordionTitleType = { text: string, onClick: any, show: boolean, subtitle?: string, imagePath?: string };

export default function AccordionTitle({ text, onClick: handleClick, show, subtitle, imagePath }: AccordionTitleType) {
  return (
    <AccordionTitleWrapper href="#" onClick={handleClick} px={{ xs: 1, md: '1.5rem' }} py={{ xs: 2, md: '1.25rem' }}>
      <Flex  align='center' justify="flex-start">
        {imagePath && <AccordionIcon image={imagePath} />}
        <Text variant="body1" weight="bold">{text}</Text>
        { subtitle && <Text variant="body2"  mr={{ xs: '0.25rem', sm: '0.75rem' }} mt={0} color={'weak'}>{subtitle}</Text>}
      </Flex>
      <RotatableIcon trigger={show} size="large" cursor='pointer'><IconDown strokeWidth={3}/></RotatableIcon>
    </AccordionTitleWrapper>
  );
}

export const AccordionIcon = ({ image }: { image: string }) => {
  const [imgSrc, setImgSrc] = useState(image);
  const fallbackImage = '/static/images/subscription-defualt-logo.png';
  const handleImageError = () => {
    setImgSrc(fallbackImage);
  };
  return <Flex ml='0.5rem'>
    <AccordionTitleImage  src={imgSrc || fallbackImage} maxWidth="100%" objectFit="contain"
      onError={handleImageError}/>
  </Flex>;
};
